// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

/* One weekly planning: state icon, name/description (opens the time bands), active switch,
 * actions always visible */
.planning-row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 10px 12px 16px;
  transition: background-color 0.15s ease;
}
.planning-row:hover {
  background: rgba(var(--ion-color-primary-rgb), 0.06);
}
.planning-row__icon {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 50%;
}
.planning-row__icon ion-icon {
  font-size: 22px;
  transition: color 0.15s linear;
}
.planning-row__main {
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex: 1;
  min-width: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}
.planning-row__main:focus-visible {
  outline: 2px solid rgba(var(--ion-color-primary-rgb), 0.5);
  outline-offset: 2px;
  border-radius: 6px;
}
.planning-row__title {
  font-size: 15px;
  font-weight: 600;
  overflow-wrap: anywhere;
}
.planning-row__description {
  font-size: 13px;
  color: var(--ion-color-medium-shade);
  overflow-wrap: anywhere;
}
.planning-row__actions {
  display: flex;
  flex-shrink: 0;
  gap: 2px;
}
.planning-row {
  /* Phones: the state pill goes under the text */
}
@media (max-width: 575px) {
  .planning-row {
    flex-wrap: wrap;
    gap: 6px 12px;
    padding: 12px 8px 12px 12px;
  }
  .planning-row__main {
    flex-basis: calc(100% - 44px - 12px - 120px - 12px);
  }
  .planning-row .state-pill {
    order: 5;
    margin-left: 56px;
  }
}

/* Active / inactive */
.state-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  padding: 4px 11px 4px 9px;
  border: 1px solid transparent;
  border-radius: 999px;
  font: inherit;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  color: var(--ion-color-medium-shade);
  background: rgba(var(--ion-color-medium-rgb), 0.14);
}
.state-pill__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--ion-color-medium);
}
.state-pill--on {
  color: var(--ion-color-success-shade);
  background: rgba(var(--ion-color-success-rgb), 0.12);
}
.state-pill--on .state-pill__dot {
  background: var(--ion-color-success);
}
.state-pill--button {
  cursor: pointer;
  transition: border-color 0.15s ease;
}
.state-pill--button:hover:not(:disabled), .state-pill--button:focus-visible {
  outline: none;
  border-color: currentColor;
}
.state-pill--button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.icon-action {
  display: grid;
  place-items: center;
  width: 38px;
  height: 38px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: var(--ion-color-medium);
  line-height: 0;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.icon-action ion-icon {
  font-size: 19px;
}
.icon-action:hover, .icon-action:focus-visible {
  outline: none;
  color: var(--ion-color-primary);
  background: rgba(var(--ion-color-primary-rgb), 0.1);
}
.icon-action--danger:hover, .icon-action--danger:focus-visible {
  color: var(--ion-color-danger);
  background: rgba(var(--ion-color-danger-rgb), 0.1);
}
.icon-action {
  /* Time bands with nothing to show yet: still tappable (it explains what is missing) */
}
.icon-action--muted {
  opacity: 0.45;
}

/* Icon state, derived from the brand primary colour (no fixed hex) */
.thumbnail-active {
  background: rgba(var(--ion-color-primary-rgb), 0.16);
}

.thumbnail-online {
  background: rgba(var(--ion-color-primary-rgb), 0.06);
}

.thumbnail-offline {
  background: rgba(var(--ion-color-medium-rgb), 0.14);
}

.icon-active {
  color: var(--ion-color-primary);
}

.icon-online {
  color: rgba(var(--ion-color-primary-rgb), 0.55);
}

.icon-offline {
  color: var(--ion-color-medium);
}`, "",{"version":3,"sources":["webpack://./src/components/general components/weekly-planning-item/weekly-planning-item.component.scss","webpack://./src/components/general%20components/weekly-planning-item/weekly-planning-item.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;ACCF;;ADEA;2BAAA;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,4BAAA;EACA,uCAAA;ACCF;ADCE;EACE,oDAAA;ACCJ;ADEE;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;ACAJ;ADEI;EACE,eAAA;EACA,8BAAA;ACAN;ADIE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;ACFJ;ADII;EACE,0DAAA;EACA,mBAAA;EACA,kBAAA;ACFN;ADME;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;ACJJ;ADOE;EACE,eAAA;EACA,oCAAA;EACA,uBAAA;ACLJ;ADQE;EACE,aAAA;EACA,cAAA;EACA,QAAA;ACNJ;ADvDA;EAgEE,+CAAA;ACNF;ADOE;EAjEF;IAkEI,eAAA;IACA,aAAA;IACA,2BAAA;ECJF;EDME;IACE,mDAAA;ECJJ;EDOE;IACE,QAAA;IACA,iBAAA;ECLJ;AACF;;ADSA,sBAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,yBAAA;EACA,6BAAA;EACA,oBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,oCAAA;EACA,mDAAA;ACNF;ADQE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mCAAA;ACNJ;ADSE;EACE,qCAAA;EACA,oDAAA;ACPJ;ADSI;EACE,oCAAA;ACPN;ADWE;EACE,eAAA;EACA,mCAAA;ACTJ;ADWI;EAEE,aAAA;EACA,0BAAA;ACVN;ADaI;EACE,mBAAA;EACA,YAAA;ACXN;;ADgBA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,8BAAA;EACA,cAAA;EACA,eAAA;EACA,yDAAA;ACbF;ADeE;EACE,eAAA;ACbJ;ADgBE;EAEE,aAAA;EACA,+BAAA;EACA,mDAAA;ACfJ;ADkBE;EAEE,8BAAA;EACA,kDAAA;ACjBJ;ADXA;EA+BE,sFAAA;ACjBF;ADkBE;EACE,aAAA;AChBJ;;ADoBA,qEAAA;AACA;EACE,oDAAA;ACjBF;;ADoBA;EACE,oDAAA;ACjBF;;ADoBA;EACE,mDAAA;ACjBF;;ADoBA;EACE,+BAAA;ACjBF;;ADoBA;EACE,+CAAA;ACjBF;;ADoBA;EACE,8BAAA;ACjBF","sourcesContent":[":host {\n  display: block;\n}\n\n/* One weekly planning: state icon, name/description (opens the time bands), active switch,\n * actions always visible */\n.planning-row {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 12px 10px 12px 16px;\n  transition: background-color 0.15s ease;\n\n  &:hover {\n    background: rgba(var(--ion-color-primary-rgb), 0.06);\n  }\n\n  &__icon {\n    display: grid;\n    place-items: center;\n    flex-shrink: 0;\n    width: 44px;\n    height: 44px;\n    border-radius: 50%;\n\n    ion-icon {\n      font-size: 22px;\n      transition: color 0.15s linear;\n    }\n  }\n\n  &__main {\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n    flex: 1;\n    min-width: 0;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    color: inherit;\n    font: inherit;\n    text-align: left;\n    cursor: pointer;\n\n    &:focus-visible {\n      outline: 2px solid rgba(var(--ion-color-primary-rgb), 0.5);\n      outline-offset: 2px;\n      border-radius: 6px;\n    }\n  }\n\n  &__title {\n    font-size: 15px;\n    font-weight: 600;\n    overflow-wrap: anywhere;\n  }\n\n  &__description {\n    font-size: 13px;\n    color: var(--ion-color-medium-shade);\n    overflow-wrap: anywhere;\n  }\n\n  &__actions {\n    display: flex;\n    flex-shrink: 0;\n    gap: 2px;\n  }\n\n  /* Phones: the state pill goes under the text */\n  @media (max-width: 575px) {\n    flex-wrap: wrap;\n    gap: 6px 12px;\n    padding: 12px 8px 12px 12px;\n\n    &__main {\n      flex-basis: calc(100% - 44px - 12px - 120px - 12px);\n    }\n\n    .state-pill {\n      order: 5;\n      margin-left: 56px;\n    }\n  }\n}\n\n/* Active / inactive */\n.state-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n  padding: 4px 11px 4px 9px;\n  border: 1px solid transparent;\n  border-radius: 999px;\n  font: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n  color: var(--ion-color-medium-shade);\n  background: rgba(var(--ion-color-medium-rgb), 0.14);\n\n  &__dot {\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    background: var(--ion-color-medium);\n  }\n\n  &--on {\n    color: var(--ion-color-success-shade);\n    background: rgba(var(--ion-color-success-rgb), 0.12);\n\n    .state-pill__dot {\n      background: var(--ion-color-success);\n    }\n  }\n\n  &--button {\n    cursor: pointer;\n    transition: border-color 0.15s ease;\n\n    &:hover:not(:disabled),\n    &:focus-visible {\n      outline: none;\n      border-color: currentColor;\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.6;\n    }\n  }\n}\n\n.icon-action {\n  display: grid;\n  place-items: center;\n  width: 38px;\n  height: 38px;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--ion-color-medium);\n  line-height: 0;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease;\n\n  ion-icon {\n    font-size: 19px;\n  }\n\n  &:hover,\n  &:focus-visible {\n    outline: none;\n    color: var(--ion-color-primary);\n    background: rgba(var(--ion-color-primary-rgb), 0.1);\n  }\n\n  &--danger:hover,\n  &--danger:focus-visible {\n    color: var(--ion-color-danger);\n    background: rgba(var(--ion-color-danger-rgb), 0.1);\n  }\n\n  /* Time bands with nothing to show yet: still tappable (it explains what is missing) */\n  &--muted {\n    opacity: 0.45;\n  }\n}\n\n/* Icon state, derived from the brand primary colour (no fixed hex) */\n.thumbnail-active {\n  background: rgba(var(--ion-color-primary-rgb), 0.16);\n}\n\n.thumbnail-online {\n  background: rgba(var(--ion-color-primary-rgb), 0.06);\n}\n\n.thumbnail-offline {\n  background: rgba(var(--ion-color-medium-rgb), 0.14);\n}\n\n.icon-active {\n  color: var(--ion-color-primary);\n}\n\n.icon-online {\n  color: rgba(var(--ion-color-primary-rgb), 0.55);\n}\n\n.icon-offline {\n  color: var(--ion-color-medium);\n}\n",":host {\n  display: block;\n}\n\n/* One weekly planning: state icon, name/description (opens the time bands), active switch,\n * actions always visible */\n.planning-row {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 12px 10px 12px 16px;\n  transition: background-color 0.15s ease;\n}\n.planning-row:hover {\n  background: rgba(var(--ion-color-primary-rgb), 0.06);\n}\n.planning-row__icon {\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n}\n.planning-row__icon ion-icon {\n  font-size: 22px;\n  transition: color 0.15s linear;\n}\n.planning-row__main {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  flex: 1;\n  min-width: 0;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n.planning-row__main:focus-visible {\n  outline: 2px solid rgba(var(--ion-color-primary-rgb), 0.5);\n  outline-offset: 2px;\n  border-radius: 6px;\n}\n.planning-row__title {\n  font-size: 15px;\n  font-weight: 600;\n  overflow-wrap: anywhere;\n}\n.planning-row__description {\n  font-size: 13px;\n  color: var(--ion-color-medium-shade);\n  overflow-wrap: anywhere;\n}\n.planning-row__actions {\n  display: flex;\n  flex-shrink: 0;\n  gap: 2px;\n}\n.planning-row {\n  /* Phones: the state pill goes under the text */\n}\n@media (max-width: 575px) {\n  .planning-row {\n    flex-wrap: wrap;\n    gap: 6px 12px;\n    padding: 12px 8px 12px 12px;\n  }\n  .planning-row__main {\n    flex-basis: calc(100% - 44px - 12px - 120px - 12px);\n  }\n  .planning-row .state-pill {\n    order: 5;\n    margin-left: 56px;\n  }\n}\n\n/* Active / inactive */\n.state-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n  padding: 4px 11px 4px 9px;\n  border: 1px solid transparent;\n  border-radius: 999px;\n  font: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n  color: var(--ion-color-medium-shade);\n  background: rgba(var(--ion-color-medium-rgb), 0.14);\n}\n.state-pill__dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--ion-color-medium);\n}\n.state-pill--on {\n  color: var(--ion-color-success-shade);\n  background: rgba(var(--ion-color-success-rgb), 0.12);\n}\n.state-pill--on .state-pill__dot {\n  background: var(--ion-color-success);\n}\n.state-pill--button {\n  cursor: pointer;\n  transition: border-color 0.15s ease;\n}\n.state-pill--button:hover:not(:disabled), .state-pill--button:focus-visible {\n  outline: none;\n  border-color: currentColor;\n}\n.state-pill--button:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.icon-action {\n  display: grid;\n  place-items: center;\n  width: 38px;\n  height: 38px;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--ion-color-medium);\n  line-height: 0;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n.icon-action ion-icon {\n  font-size: 19px;\n}\n.icon-action:hover, .icon-action:focus-visible {\n  outline: none;\n  color: var(--ion-color-primary);\n  background: rgba(var(--ion-color-primary-rgb), 0.1);\n}\n.icon-action--danger:hover, .icon-action--danger:focus-visible {\n  color: var(--ion-color-danger);\n  background: rgba(var(--ion-color-danger-rgb), 0.1);\n}\n.icon-action {\n  /* Time bands with nothing to show yet: still tappable (it explains what is missing) */\n}\n.icon-action--muted {\n  opacity: 0.45;\n}\n\n/* Icon state, derived from the brand primary colour (no fixed hex) */\n.thumbnail-active {\n  background: rgba(var(--ion-color-primary-rgb), 0.16);\n}\n\n.thumbnail-online {\n  background: rgba(var(--ion-color-primary-rgb), 0.06);\n}\n\n.thumbnail-offline {\n  background: rgba(var(--ion-color-medium-rgb), 0.14);\n}\n\n.icon-active {\n  color: var(--ion-color-primary);\n}\n\n.icon-online {\n  color: rgba(var(--ion-color-primary-rgb), 0.55);\n}\n\n.icon-offline {\n  color: var(--ion-color-medium);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
